"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _excluded = ["classes", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      top: theme.spacing.unit,
      left: theme.spacing.unit * 1.5,
      zIndex: theme.zIndex.appBar + 2,
      color: theme.palette.common.white,
      backgroundColor: 'rgba(0,0,0,0.08)',
      '&:hover': {
        backgroundColor: 'rgba(0,0,0,0.12)'
      }
    } // someState: {},

  };
};

var DetailViewCloseButton = function DetailViewCloseButton(_ref) {
  var classes = _ref.classes,
      classNameProp = _ref.className,
      other = _objectWithoutProperties(_ref, _excluded);

  var className = (0, _classnames["default"])(classes.root, {// [classes.someState]: prop_expression_here,
  }, classNameProp);
  return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], _extends({
    className: className
  }, other), /*#__PURE__*/_react["default"].createElement(_Close["default"], null));
};

DetailViewCloseButton.propTypes = {
  classes: _propTypes["default"].object.isRequired,
  className: _propTypes["default"].string
};
DetailViewCloseButton.defaultProps = {
  className: ''
};

var _default = (0, _styles.withStyles)(styles)(DetailViewCloseButton);

exports["default"] = _default;